export default "__VITE_ASSET__CSb5Ec0Y__"